import i18next from 'i18next'

import de from './de.json'
import en from './en.json'

export const loadTranslations = () => {
  i18next.addResourceBundle('de', 'translations', de)
  i18next.addResourceBundle('en', 'translations', en)
}
